var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"alt":"Vue logo","src":require("./assets/banner1.png")}}),_c('HelloWorld')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }